
const handleOptionListData=(OptionList) => {
  try {
    return OptionList.map(item=>`${item.value}`);
  } catch (error) {
    throw new Error("Error in Options list")
  }
}

export default handleOptionListData;